<template>
  <div class="lundao-share-config" v-loading="loading">
    <div class="config-section">
      <el-tag>全局管理</el-tag>
      <div class="config-content">
        <div class="switch-item">
          <span>开启返现功能</span>
          <el-switch v-model="paperConfig.cashBackEnable" :active-value="'1'" :inactive-value="'0'"></el-switch>
        </div>
      </div>
    </div>

    <div class="divider"></div>

    <div class="config-section">
      <el-tag>返现配置</el-tag>
      <div class="config-content">
        <div class="input-item">
          <span>单笔订单返现金额 （直接代理人）</span>
          <el-input
            v-model="paperConfig.singleBackAmount"
            size="small"
            style="width: 80px"
            @input="handleInput"
            @blur="handleBlur">
          </el-input>
          <span class="unit">元</span>
        </div>
      </div>
      <div class="config-content">
        <div class="input-item">
          <span>单笔订单返现金额 （间接代理人）</span>
          <el-input
            v-model="paperConfig.indirectBackAmount"
            size="small"
            style="width: 80px"
            @input="handleIndirectInput"
            @blur="handleIndirectBlur">
          </el-input>
          <span class="unit">元</span>
        </div>
      </div>
    </div>

    <div class="divider"></div>

    <div class="config-section">
      <el-tag>订单价格配置</el-tag>
      <div class="config-content">
        <div class="input-item">
          <span>直接进入的单笔订单价格</span>
          <el-input
            v-model="paperConfig.amount"
            size="small"
            style="width: 80px"
            @input="value => handlePriceInput(value, 'amount')"
            @blur="() => handlePriceBlur('amount')">
          </el-input>
          <span class="unit">元</span>
        </div>
        <div class="input-item" style="margin-top: 15px;">
          <span>折扣价</span>
          <el-input
            v-model="paperConfig.discountAmount"
            size="small"
            style="width: 80px"
            @input="value => handlePriceInput(value, 'discountAmount')"
            @blur="() => handlePriceBlur('discountAmount')">
          </el-input>
          <span class="unit">元</span>
        </div>
      </div>
    </div>

    <div class="save-button-container">
      <a href="javascript:" class="btn btn btn-solid-primary" @click="handleSave">保存</a>
    </div>
  </div>
</template>

<script>
import util from '../../../libs/util'
export default {
  name: 'lundao-share-config',
  data() {
    return {
      paperConfig: {
        id: '',
        cashBackEnable: '1',
        singleBackAmount: '',
        indirectBackAmount: '',
        amount: '',
        discountAmount: ''
      },
      loading: false // 添加loading状态
    }
  },
  created() {
    this.getConfig()
  },
  methods: {
    // 获取配置信息
    async getConfig() {
      this.loading = true
      util.ajax.get('/entity/dev/paperConfig').then(res => {
        if (res.data.meta.errCode === 0) {
          this.paperConfig = res.data.data
          if (!this.paperConfig.cashBackEnable) {
            this.paperConfig.cashBackEnable = '1'
          }
          if (!this.paperConfig.singleBackAmount) {
            this.paperConfig.singleBackAmount = '20.00'
          } else {
            this.paperConfig.singleBackAmount = Number(this.paperConfig.singleBackAmount).toFixed(2)
          }
          console.log(this.paperConfig)
        } else {
          this.$notify.error({title: '错误', message: res.data.meta.errMsg})
        }
        this.loading = false
      }).catch(err => {
        this.$notify.error({title: '错误', message: '获取配置失败'})
        console.error(err)
        this.loading = false
      })
    },
    // 保存配置信息
    async saveConfig() {
      // 添加价格验证
      const backAmount = Number(this.paperConfig.singleBackAmount)
      const sharedPrice = Number(this.paperConfig.discountAmount)
      const indirectBackAmount = Number(this.paperConfig.indirectBackAmount)

      if (backAmount + indirectBackAmount >= sharedPrice) {
        this.$notify.warning({
          title: '警告',
          message: '返现金额总和不能大于或等于折扣价'
        })
        return
      }

      this.loading = true
      util.ajax.post('/entity/dev/paperConfig/save', this.paperConfig).then(res => {
        if (res.data.meta.errCode === 0) {
          this.paperConfig.id = res.data.data.id
          this.$notify.success({title: '成功', message: '保存配置成功'})
        } else {
          this.$notify.error({title: '错误', message: res.data.meta.errMsg})
        }
        this.loading = false
      }).catch(err => {
        this.$notify.error({title: '错误', message: '保存配置失败'})
        console.error(err)
        this.loading = false
      })
    },
    handleInput(value) {
      // 只允许输入数字和小数点
      value = value.replace(/[^\d.]/g, '')
      // 保证只有一个小数点
      value = value.replace(/\.{2,}/g, '.')
      // 保证小数点只出现一次
      value = value.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
      // 保证两位小数
      if (value.indexOf('.') > -1) {
        value = value.slice(0, value.indexOf('.') + 3)
      }
      // 限制最大值为100
      if (Number(value) > 99.99) {
        value = '99.99'
      }
      this.paperConfig.singleBackAmount = value
    },
    handleBlur() {
      // 失去焦点时确保是合法的数字
      if (this.paperConfig.singleBackAmount === '') {
        this.paperConfig.singleBackAmount = '20.00'
      }
      // 确保有两位小数
      if (this.paperConfig.singleBackAmount.indexOf('.') === -1) {
        this.paperConfig.singleBackAmount = Number(this.paperConfig.singleBackAmount).toFixed(2)
      } else {
        this.paperConfig.singleBackAmount = Number(this.paperConfig.singleBackAmount).toFixed(2)
      }
    },
    handlePriceInput(value, field) {
      // 只允许输入数字和小数点
      value = value.replace(/[^\d.]/g, '')
      // 保证只有一个小数点
      value = value.replace(/\.{2,}/g, '.')
      // 保证小数点只出现一次
      value = value.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
      // 保证两位小数
      if (value.indexOf('.') > -1) {
        value = value.slice(0, value.indexOf('.') + 3)
      }
      // 限制最大值为1000
      if (Number(value) > 999.99) {
        value = '999.99'
      }
      this.paperConfig[field] = value
    },
    handlePriceBlur(field) {
      // 失去焦点时确保是合法的数字
      if (this.paperConfig[field] === '') {
        if (field === 'amount') {
          this.paperConfig[field] = '99.90'
        } else {
          this.paperConfig[field] = '19.90'
        }
      }
      // 确保有两位小数
      this.paperConfig[field] = Number(this.paperConfig[field]).toFixed(2)
    },
    handleIndirectInput(value) {
      // 只允许输入数字和小数点
      value = value.replace(/[^\d.]/g, '')
      // 保证只有一个小数点
      value = value.replace(/\.{2,}/g, '.')
    },
    handleIndirectBlur() {
      // 失去焦点时确保是合法的数字
      if (this.paperConfig.indirectBackAmount === '') {
        this.paperConfig.indirectBackAmount = '0.00'
      }
      this.paperConfig.indirectBackAmount = Number(this.paperConfig.indirectBackAmount).toFixed(2)
    },
    handleSave() {
      this.saveConfig()
    }
  }
}
</script>

<style lang="scss" scoped>
.lundao-share-config {
  padding: 20px;
  margin: 20px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  min-height: calc(100% - 80px);

  .config-section {

    .config-content {
      padding: 15px;
    }

    .switch-item, .input-item {
      display: flex;
      align-items: center;

      span {
        display: block;
        font-size: 14px;
        color: #111315;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-right: 10px;
      }

      .unit {
        margin-left: 5px;
      }
    }
  }

  .divider {
    height: 1px;
    background-color: #ebeef5;
    margin-bottom: 20px;
  }

  .save-button-container {
    text-align: center;
    margin-top: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/custom/components/paper/lundao-share-config.vue